import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import TopUpStatusMessage from './TopUpStatusMessage';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';
import messages from '../../../OutstandingView/dashboardActions/TopUpPending/TopUpPending.messages';

export const TopUpPending = () => {
    const stateKey = useStateKey();

    const {
        data: applicationResponse,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () => fetchGetApplication({ stateKey })
    });

    if (isLoading || isError) return null;

    const requestedAmount =
        applicationResponse.data!.requested_products![0]!.amount;

    const requestedCashAmount =
        applicationResponse.data!.requested_products![0].requested_cash_amount;

    return (
        <TopUpStatusMessage
            heading={<FormattedMessage {...messages.title} />}
            description={
                requestedCashAmount ? (
                    <FormattedMessage
                        {...messages.description}
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency
                                        value={requestedCashAmount}
                                    />
                                </strong>
                            )
                        }}
                    />
                ) : (
                    <FormattedMessage
                        {...messages.fallbackDescription}
                        values={{
                            amount: (
                                <strong>
                                    <FormattedCurrency
                                        value={requestedAmount!}
                                    />
                                </strong>
                            )
                        }}
                    />
                )
            }
            ctaText={<FormattedMessage {...messages.ctaText} />}
            trackEvent={() => tracking.ampli.topupChangeRequestCtaClicked()}
        />
    );
};
